import { useTranslation } from 'react-i18next'

import B2BecLink from '@/components/B2BLink'

import styles from './NotFound.module.scss'

const NotFound = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.wrapper}>
      <h1 className="text-3xl mb-4">{t('errors.pageNotFound')}</h1>
      <p className="text-sm mb-3">{t('errors.pageNotFoundMessage')}</p>
      <p className="text-sm">
        <B2BecLink to="">{t('errors.backHomeButton')}</B2BecLink>
      </p>
    </div>
  )
}

export default NotFound
